import type { NavItem } from '../types/resume';

export const navItems: NavItem[] = [
  { path: '/', label: 'Home', number: '01', description: 'Introduction and executive overview' },
  { path: '/about', label: 'About', number: '02', description: 'Professional profile and specialties' },
  { path: '/experience', label: 'Experience', number: '03', description: 'Full career history, 1984 to present' },
  { path: '/expertise', label: 'Expertise', number: '04', description: 'Competencies and endorsed skills' },
  { path: '/achievements', label: 'Achievements', number: '05', description: 'Results, transformations and milestones' },
  { path: '/journey', label: 'Journey', number: '06', description: 'Interactive career timeline' },
  { path: '/strengths', label: 'Strengths', number: '07', description: 'Qualities demonstrated across his career' },
  { path: '/education', label: 'Education', number: '08', description: 'Degrees and postgraduate studies' },
  { path: '/training', label: 'Training', number: '09', description: 'Courses, seminars and languages' },
  { path: '/contact', label: 'Contact', number: '10', description: 'Professional enquiries' },
];
